module.exports = __webpack_public_path__ + "static/calorex_home_slide_familia_calorex_tb-8fd0accde4ee8c39f9e2564cf9c47dfb.png";